/* Colorway Catch header — menu interactions and on-demand thumbnail loading.
   Product links remain server-rendered. Supports multiple header instances. */
(function () {
  "use strict";

  function init(header) {
    var links = header.querySelectorAll(".cc-link[data-menu]");
    var panels = header.querySelectorAll(".cc-panelwrap[data-menu]");
    var scrim = header.querySelector(".cc-scrim");
    var closeTimer = null;
    var openMenu = null;

    function panelFor(id) { return header.querySelector('.cc-panelwrap[data-menu="' + id + '"]'); }

    function hydrateThumbs(root) {
      if (!root) return;
      var selector = ".cc-thumb[data-cc-image]:not([data-hydrated])";
      var thumbs = [];
      if (root.matches && root.matches(selector)) thumbs.push(root);
      root.querySelectorAll(selector).forEach(function (thumb) { thumbs.push(thumb); });
      thumbs.forEach(function (thumb) {
        var src = thumb.getAttribute("data-src");
        if (!src) return;
        var size = Number(thumb.getAttribute("data-width")) || 220;
        var img = document.createElement("img");
        img.src = src;
        img.alt = thumb.getAttribute("data-alt") || "";
        img.width = size;
        img.height = size;
        img.loading = "eager";
        img.decoding = "async";
        img.fetchPriority = "low";
        thumb.setAttribute("data-hydrated", "true");
        thumb.appendChild(img);
      });
    }

    function hydrateMenu(id) {
      hydrateThumbs(panelFor(id));
    }

    function setOpen(id) {
      openMenu = id;
      panels.forEach(function (p) {
        var on = p.getAttribute("data-menu") === id;
        p.classList.toggle("is-open", on);
        if (on) p.removeAttribute("hidden"); else p.setAttribute("hidden", "");
      });
      links.forEach(function (l) {
        var on = l.getAttribute("data-menu") === id;
        l.classList.toggle("is-open", on);
        l.setAttribute("aria-expanded", on ? "true" : "false");
      });
      if (scrim) { if (id) scrim.removeAttribute("hidden"); else scrim.setAttribute("hidden", ""); }
    }

    function enter(id) { clearTimeout(closeTimer); hydrateMenu(id); setOpen(id); }
    function leave() { clearTimeout(closeTimer); closeTimer = setTimeout(function () { setOpen(null); }, 150); }
    function stay() { clearTimeout(closeTimer); }

    links.forEach(function (l) {
      var id = l.getAttribute("data-menu");
      l.addEventListener("mouseenter", function () { enter(id); });
      l.addEventListener("focus", function () { enter(id); });
      l.addEventListener("keydown", function (e) {
        if (e.key === "Tab" && !e.shiftKey && openMenu === id) {
          var firstPanelLink = panelFor(id) && panelFor(id).querySelector("a[href], button:not([disabled])");
          if (firstPanelLink) { e.preventDefault(); firstPanelLink.focus(); }
        }
      });
      // click: open if closed; if already open, follow through to the collection page
      l.addEventListener("click", function (e) {
        e.preventDefault();
        if (openMenu === id) {
          var href = l.getAttribute("data-href");
          if (href) { window.location.href = href; return; }
          setOpen(null); return;
        }
        hydrateMenu(id);
        setOpen(id);
      });
    });
    panels.forEach(function (p) {
      p.addEventListener("mouseenter", stay);
      p.addEventListener("mouseleave", leave);
    });
    header.addEventListener("mouseleave", leave);
    if (scrim) scrim.addEventListener("mouseenter", function () { setOpen(null); });
    if (scrim) scrim.addEventListener("click", function () { setOpen(null); });

    // search expand (desktop)
    var searchBox = header.querySelector(".cc-bar .cc-search");
    var searchBtn = header.querySelector(".cc-searchbtn");
    if (searchBox && searchBtn) {
      var input = searchBox.querySelector("input");
      searchBtn.addEventListener("click", function () {
        searchBox.classList.add("is-open"); searchBtn.style.display = "none";
        if (input) input.focus();
      });
      if (input) input.addEventListener("blur", function () {
        if (!input.value) { searchBox.classList.remove("is-open"); searchBtn.style.display = ""; }
      });
    }

    // mobile drawer
    var drawer = header.querySelector(".cc-drawer");
    var mscrim = header.querySelector(".cc-mscrim");
    var menuBtn = header.querySelector(".cc-menubtn");
    var backgroundState = new Map();
    var backgroundTargets = Array.from(document.querySelectorAll("main, footer")).concat(
      Array.from(header.children).filter(function (child) {
        return !child.classList.contains("cc-drawerwrap");
      })
    );

    function setBackgroundInert(open) {
      backgroundTargets.forEach(function (target) {
        if (open) {
          if (!backgroundState.has(target)) {
            backgroundState.set(target, {
              inert: target.inert,
              ariaHidden: target.getAttribute("aria-hidden")
            });
          }
          target.inert = true;
          target.setAttribute("aria-hidden", "true");
          return;
        }
        var previous = backgroundState.get(target);
        if (!previous) return;
        target.inert = previous.inert;
        if (previous.ariaHidden === null) target.removeAttribute("aria-hidden");
        else target.setAttribute("aria-hidden", previous.ariaHidden);
      });
      if (!open) backgroundState.clear();
    }

    function setDrawerState(open) {
      if (!drawer) return;
      var wasOpen = drawer.classList.contains("is-open");
      drawer.classList.toggle("is-open", open);
      drawer.setAttribute("aria-hidden", open ? "false" : "true");
      drawer.inert = !open;
      if (mscrim) {
        mscrim.classList.toggle("is-open", open);
        mscrim.tabIndex = open ? 0 : -1;
      }
      if (menuBtn) menuBtn.setAttribute("aria-expanded", open ? "true" : "false");
      document.body.classList.toggle("overflow-hidden", open);
      setBackgroundInert(open);
      if (open) {
        var firstFocus = drawer.querySelector(".cc-dclose, input, a[href], button:not([disabled])");
        if (firstFocus) firstFocus.focus(); else drawer.focus();
      } else if (wasOpen && menuBtn) {
        menuBtn.focus();
      }
    }
    var drawerImageObserver = null;
    function hydrateVisibleDrawerSections() {
      if (!drawer) return;
      var thumbs = drawer.querySelectorAll(".cc-thumb[data-cc-image]:not([data-hydrated])");
      if (!("IntersectionObserver" in window)) {
        Array.prototype.slice.call(thumbs, 0, 12).forEach(hydrateThumbs);
        return;
      }
      if (!drawerImageObserver) {
        drawerImageObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            hydrateThumbs(entry.target);
            drawerImageObserver.unobserve(entry.target);
          });
        }, { root: drawer, rootMargin: "60px" });
      }
      thumbs.forEach(function (thumb) { drawerImageObserver.observe(thumb); });
    }
    function openDrawer() {
      setDrawerState(true);
      requestAnimationFrame(hydrateVisibleDrawerSections);
    }
    function closeDrawer() { setDrawerState(false); }
    if (drawer) drawer.inert = true;
    if (menuBtn) menuBtn.setAttribute("aria-expanded", "false");
    if (menuBtn) menuBtn.addEventListener("click", openDrawer);
    if (mscrim) mscrim.addEventListener("click", closeDrawer);
    var dclose = header.querySelector(".cc-dclose");
    if (dclose) dclose.addEventListener("click", closeDrawer);

    document.addEventListener("focusin", function (e) {
      if (!drawer || !drawer.classList.contains("is-open") || drawer.contains(e.target)) return;
      var firstFocus = drawer.querySelector(".cc-dclose, input, a[href], button:not([disabled])");
      if (firstFocus) firstFocus.focus(); else drawer.focus();
    });

    // drawer accordion
    header.querySelectorAll(".cc-drow[data-menu]").forEach(function (row) {
      var id = row.getAttribute("data-menu");
      var strip = header.querySelector('.cc-dstrip[data-menu="' + id + '"]');
      row.addEventListener("click", function () {
        var willOpen = !row.classList.contains("is-open");
        header.querySelectorAll(".cc-drow.is-open").forEach(function (r) { r.classList.remove("is-open"); });
        header.querySelectorAll(".cc-dstrip.is-open").forEach(function (s) { s.classList.remove("is-open"); });
        if (willOpen) {
          row.classList.add("is-open");
          if (strip) { hydrateThumbs(strip); strip.classList.add("is-open"); }
        }
      });
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Tab" && drawer && drawer.classList.contains("is-open")) {
        var focusable = Array.from(drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (el) {
          return !el.hidden && el.offsetParent !== null;
        });
        if (focusable.length) {
          var first = focusable[0];
          var last = focusable[focusable.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      }
      if (e.key === "Escape") { setOpen(null); closeDrawer(); }
    });
  }

  function boot() { document.querySelectorAll(".cc-header[data-cc]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
